import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'

export const getCampaignsWithNpsTableData = async ({
  countryIds,
  hasReferralProgram,
}) => {
  const query = `
        query (
          $countryIds: [ID!], $hasReferralProgram: Boolean
        ) {
          campaigns(
            countryIds:$countryIds, hasReferralProgram: $hasReferralProgram
          ){
            totalCount
            edges {
              node {
                id
                name
                type
                countryId
                client {
                  name
                  tags {
                    id
                    value
                    tagLinkId
                  }
                }  
                clientReferralProgram {
                  score
                  referralEmailDate
                  voterId
                  feedback
                }  
                activeDates {
                  start
                  end
                }
                missions ( statusAndAbove:COMPLETED) {
                  totalCount
                  edges {
                    node{
                      id
                      cancelled
                      dateTime
                    }
                  }
                }
              }
            }
          }
        }
      `

  return callAuthorizedGraphQLEndpoint(query, {
    countryIds,
    hasReferralProgram,
  })
}
